import moment from 'moment';

export const TAREA_FACTURACION_OPCIONES = [
  { value: '', label: 'Todas' },
  { value: 'ADMINISTRACION HORAS', label: 'ADMINISTRACION HORAS' },
  { value: 'PRECIO CERRADO', label: 'PRECIO CERRADO' },
  { value: 'NO FACTURABLE', label: 'NO FACTURABLE' },
  { value: 'ADMINISTRACION + DESPLAZAMIENTO', label: 'ADMINISTRACION + DESPLAZAMIENTO' },
  { value: 'ADMINISTRACION TODO', label: 'ADMINISTRACION TODO' },
];

export const ESTADO_SAT_OPCIONES = [
  { value: '', label: 'Todos' },
  { value: 'Cancelado', label: 'Cancelado' },
  { value: 'Enviado al cliente por email', label: 'Enviado al cliente por email' },
  { value: 'Facturado', label: 'Facturado' },
  { value: 'Finalizado SAT', label: 'Finalizado SAT' },
  { value: 'Pendiente', label: 'Pendiente' },
];

export const unwrapFlexy = (val) => {
  if (val == null) return null;
  if (typeof val === 'object') {
    if ('Value' in val || 'Text' in val) {
      const v = val.Text ?? val.Value;
      return v != null && v !== '' ? v : null;
    }
    return null;
  }
  return val;
};

export const displayParteField = (val, fallback = '—') => {
  const u = unwrapFlexy(val);
  if (u == null || u === '') return fallback;
  return u;
};

export const formatParteDate = (date) => {
  const raw = unwrapFlexy(date);
  if (!raw) return '—';
  return moment(raw).format('DD/MM/YYYY');
};

export const formatParteDateTime = (date) => {
  if (!date) return '—';
  return moment(date).format('DD/MM/YYYY HH:mm');
};

export const formatParteTime = (time) => {
  if (!time) return '—';
  if (typeof time === 'string' && time.match(/^\d{2}:\d{2}/)) return time.slice(0, 5);
  return formatParteDateTime(time);
};

export const getParteCalendarDate = (item) => {
  const parte = item && item.parte_sat;
  const albaran = item && item.albaran;
  const raw =
    (parte && (parte.fechaInicio || parte.fechaParte)) ||
    (albaran && albaran.fecha_entrega);
  if (!raw) return null;
  return moment(raw).format('YYYY-MM-DD');
};

export const getParteTitulo = (item) => {
  const parte = item && item.parte_sat;
  if (!parte) return (item && item.albaran && item.albaran.numero) || 'Sin parte';
  const titulo = unwrapFlexy(parte.titulo);
  const desc = unwrapFlexy(parte.descripcion);
  const num = getParteNumero(item);
  return titulo || desc || (num !== '—' ? `Parte ${num}` : 'Sin parte');
};

export const getParteNumero = (item) => {
  const parte = item && item.parte_sat;
  if (!parte) return '—';
  const num = unwrapFlexy(parte.numParte) ?? unwrapFlexy(parte.idParte);
  return num != null ? String(num) : '—';
};

export const filterItems = (items, { search, estadoAlbaran, estadoSat, tareaFacturacion }) => {
  let result = (items || []).filter((item) => {
    const id = unwrapFlexy(item.parte_sat?.idParte);
    return id != null && id !== '';
  });

  if (estadoSat) {
    result = result.filter(
      (item) => item.parte_sat && item.parte_sat.estadoSat === estadoSat
    );
  }

  if (estadoAlbaran) {
    result = result.filter((item) => item.albaran && item.albaran.estado === estadoAlbaran);
  }

  if (tareaFacturacion) {
    result = result.filter(
      (item) =>
        item.parte_sat &&
        item.parte_sat.tareaFacturacion &&
        item.parte_sat.tareaFacturacion.toUpperCase() === tareaFacturacion.toUpperCase()
    );
  }

  if (search && search.trim()) {
    const q = search.trim().toLowerCase();
    result = result.filter((item) => {
      const albaran = item.albaran || {};
      const parte = item.parte_sat || {};
      const haystack = [
        albaran.numero,
        albaran.cliente,
        unwrapFlexy(parte.numParte),
        unwrapFlexy(parte.idParte),
        unwrapFlexy(parte.titulo),
        unwrapFlexy(parte.descripcion),
        unwrapFlexy(parte.empleado),
        unwrapFlexy(parte.cliente),
        unwrapFlexy(parte.proyecto),
        unwrapFlexy(parte.tareaFacturacion),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      return haystack.includes(q);
    });
  }

  return result;
};

/** Etiqueta corta para badges de coherencia en la lista */
export const formatCoherenciaBadge = (alerta) => {
  if (!alerta) return alerta;
  const lower = String(alerta).toLowerCase();
  if (lower.includes('sin material')) return 'SIN MATERIALES';
  if (lower.includes('material entregado sin parte')) return 'SIN PARTE SAT';
  return alerta;
};

export const getCoherenciaBadgeClass = (alerta) => {
  const label = formatCoherenciaBadge(alerta);
  if (label === 'SIN MATERIALES') return 'badge-sin-materiales';
  if (label === 'SIN PARTE SAT') return 'badge-sin-parte';
  return 'badge-warning';
};

/** Badges de resumen de material del albarán (activos / consumibles) */
export const getMaterialResumenBadges = (materialAlbaran) => {
  if (!materialAlbaran?.total) return [];

  const badges = [];
  if (materialAlbaran.activos) {
    badges.push({
      label: `${materialAlbaran.activos} ACTIVO${materialAlbaran.activos > 1 ? 'S' : ''}`,
      class: 'badge-activos',
    });
  }
  if (materialAlbaran.consumibles) {
    badges.push({
      label: `${materialAlbaran.consumibles} CONSUMIBLE${materialAlbaran.consumibles > 1 ? 'S' : ''}`,
      class: 'badge-consumibles',
    });
  }
  if (materialAlbaran.sacas) {
    badges.push({
      label: `${materialAlbaran.sacas} SACA${materialAlbaran.sacas > 1 ? 'S' : ''}`,
      class: 'badge-sacas',
    });
  }
  return badges;
};
